import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useSectionOpenPref = (key: string, defaultValue = true): UsePrefState<boolean> =>
  usePrefState(key, defaultValue);
